<div
  class="step-indicator-circle"
  [style.width]="circleSize"
  [style.height]="circleSize"
  [style.background-color]="enabled ? enabledColor : disabledColor"
  [class.enabled]="enabled"
  [class.disabled]="!enabled">
  <span
    class="step-number"
    [style.font-size]="fontSize">
    {{ stepNumber }}
  </span>
</div>